import * as Yup from "yup";

export const VehicleCCSchema = Yup.object({

    cc: Yup.string().required("Enter Vehicle CC "),
    status: Yup.string().required("Select Status"),
});